import * as React from 'react';
export var slotTranslation = function (children) {
    if (children && Array.isArray(children)) {
        var childrenBySlot_1 = {
            default: [],
        };
        for (var i = 0; i < children.length; i++) {
            var child = children[i];
            if (child) {
                if (!child.props || !child.props.slot) {
                    childrenBySlot_1.default.push(child);
                }
                if (child.props && child.props.slot) {
                    var slot = child.props.slot;
                    childrenBySlot_1[slot]
                        ? childrenBySlot_1[slot].push(child)
                        : (childrenBySlot_1[slot] = [child]);
                }
            }
        }
        var slots_1 = [];
        Object.keys(childrenBySlot_1).forEach(function (slotKey) {
            if (slotKey === 'default') {
                slots_1.push(React.createElement("div", { key: slotKey, "data-wrapper-children": true }, childrenBySlot_1[slotKey]));
            }
            else {
                slots_1.push.apply(slots_1, childrenBySlot_1[slotKey]);
            }
        });
        return slots_1;
    }
    return children;
};
//# sourceMappingURL=slot-translation.js.map